export function GetAuditLogLevelTranslationKey(
  logLevel: number | null | undefined
): string {
  switch (logLevel) {
    case 0:
      return "auditLogLevelDebug";
    case 1:
      return "auditLogLevelInfo";
    case 2:
      return "auditLogLevelWarning";
    case 3:
      return "auditLogLevelError";
    default:
      return "auditLogLevelUnknown";
  }
}

/**
 * Used for displaying ObjectStatus with the right color for process instance statuses.
 * Colors are:
 * color grey, ObjectStatus.state: None
 * color orange, ObjectStatus.state: Warning
 * color green, ObjectStatus.state: Success
 * color red, ObjectStatus.state: Error
 * color blue, ObjectStatus.state: Information
 * color purple, ObjectStatus.state: Indication06
 * @returns state parameter for ObjectStatus
 */
export function GetStateForAuditLogLevel(
  logLevel: number | null | undefined
): string {
  switch (logLevel) {
    case 0:
      return "Success";
    case 1:
      return "Information";
    case 2:
      return "Warning";
    case 3:
      return "Error";
    default:
      return "None";
  }
}
